<template>
  <NuxtLayout name="search-basic-layout">
    <ArticleTemplate>
      <ArticleContent :title="title"
                      :article-data="data1"
                      :search-query="data2"></ArticleContent>
    </ArticleTemplate>
  </NuxtLayout>
</template>
<script setup
        lang="ts">


definePageMeta({
  name: 'article-detail',
  title: '文章'
})

import ArticleTemplate from "@/components/SearchIndex/BlogArticle/ArticleTemplate.vue";
import ArticleContent from "~/components/SearchIndex/BlogArticle/ArticleContent.vue";
import {ref} from "vue";
import {articleDetail} from "@/api/banner";
import {useBasicLayoutStore} from "~/stores/basicLayout";
const route = useRoute();
const basicLayoutStore = useBasicLayoutStore();
const title = ref('');
const data1 = ref(null);
const data2 = ref(null);
const data3 = ref(null);
const picUrl = import.meta.env.VITE_APP_BASE_IMG_URL







// ssr
const {data: BannerDetailData} = await useAsyncData('getBannerDetail', () => articleDetail(route.params.slug.toString()));
if (BannerDetailData.value && BannerDetailData.value.subject) {
  title.value = BannerDetailData.value.subject
  data1.value = BannerDetailData.value.data1
  data2.value = BannerDetailData.value.data2
  data3.value = BannerDetailData.value.data3
  basicLayoutStore.setBreadcrumb(BannerDetailData.value.subject)

  const seoMeta = {
    title: BannerDetailData.value.subject,
    description: BannerDetailData.value.data3 || '',
    ogTitle: BannerDetailData.value.subject,
    ogSiteName: '空間便利店',
    ogDescription: BannerDetailData.value.data3 || '',
    ogUrl: 'https://www.onestep.place',
    ogType: 'website',
    ogImage: BannerDetailData.value.photo_url ? `${picUrl}${BannerDetailData.value.photo_url}` : '',
    ogImageAlt: `${BannerDetailData.value.subject}｜線上預約！空間便利店`
  };


  useSeoMeta(seoMeta);
  useHead({
    script: [
      {
        type: 'application/ld+json',
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Article",
          "headline": BannerDetailData.value.subject,
          "articleBody": BannerDetailData.value.data3 ? [BannerDetailData.value.data3] : []
        })
      }
    ]
  });


}



</script>
<style scoped
       lang="scss">

</style>
